import React, { useEffect, useRef, useState } from "react";
import Badge from "components/badge/badge";
import Button from "components/button";
import { Delete, Dots, Modify } from "assets/icons";
import UseContext from "hooks/useContext";
import useModal from "components/modal/useModal";

/** Libellés alignés sur Workfully company + rôle Jobbiz 220. */
const ROLE_LABELS = {
    200: "Observateur",
    205: "Manageur",
    210: "Direction",
    215: "Directeur",
    220: "Superviseur",
    225: "Administrateur",
};

const TeamItem = ({ member }) => {
    const { toggle } = useModal();
    const { setAdminData, companyData, userDatas } = UseContext();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropDownRef = useRef(null);

    const roleNum = Number(member.role);
    const roleLabel = ROLE_LABELS[roleNum] ?? `Rôle ${member.role}`;
    const isAdmin = roleNum === 225;

    useEffect(() => {
        const handler = (e) => {
            if (
                !dropDownRef.current ||
                !dropDownRef.current.contains(e.target)
            ) {
                setDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    const setSelectedMember = () => {
        setAdminData({
            id: member._id,
            id_company: companyData._id,
            email: member.email,
            firstname: member.firstname,
            lastname: member.lastname,
            role: member.role,
        });
    };

    const handleModify = () => {
        setSelectedMember();
        setDropdownOpen(false);
        toggle("admin_u_modify");
    };

    const handleDeleted = () => {
        setSelectedMember();
        setDropdownOpen(false);
        toggle("admin_d_delete");
    };

    return (
        <div
            className={
                "grid grid-cols-5 border-b border-gray-100 p-4 text-sm transition-colors hover:bg-gray-50"
            }
        >
            <div className={"col-span-3 min-w-0"}>
                <div className={"flex gap-6"}>
                    <div
                        className={
                            "bg-gray-100 text-gray-600 rounded-full w-10 h-10 flex justify-center items-center text-base shrink-0"
                        }
                    >
                        {(member.firstname || "").charAt(0)}
                        {(member.lastname || "").charAt(0)}
                    </div>
                    <div className={"flex flex-col min-w-0"}>
                        <div className={"font-semibold flex gap-1 items-center flex-wrap"}>
                            <span>{member.firstname}</span>
                            <span>{member.lastname}</span>
                            {member._id === userDatas?._id && (
                                <span>(Vous)</span>
                            )}
                        </div>
                        <div className={"text-gray-500"}>{member.email}</div>
                    </div>
                </div>
            </div>
            <div className={"flex items-center"}>
                {/* One badge for every role; the administrator stands out by its brand tone. */}
                <Badge type={isAdmin ? "WARNING" : "PRIMARY"}>{roleLabel}</Badge>
            </div>
            <div className={"flex justify-end items-center"}>
                <div
                    className={"w-fit relative"}
                    ref={dropDownRef}
                    onClick={() => setDropdownOpen(!dropdownOpen)}
                >
                    <Button size={"TABLE"} color={"TABLE"}>
                        <Dots w={14} h={4} color={"#374151"} />
                    </Button>
                    {dropdownOpen && (
                        <div
                            className={
                                "absolute border-2 border-[#F3F4F6] rounded-lg shadow-lg h-30 w-56 bottom-9 right-0 z-50 bg-gray-50"
                            }
                        >
                            <div
                                className="flex flex-row gap-2 items-center h-9 p-2 ft-sm cursor-pointer"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleModify();
                                }}
                            >
                                <Modify wh={14} color={"#111827"} />
                                Modifier
                            </div>
                            {!isAdmin && (
                                <div
                                    className="flex flex-row gap-2 items-center h-9 p-2 ft-sm text-red-500 cursor-pointer"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleDeleted();
                                    }}
                                >
                                    <Delete wh={14} color={"#DC2626"} />
                                    Supprimer
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TeamItem;
